import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Form from "components/molecules/Form/Form";
import React from "react";
import styled from "styled-components";

const StyledTextSection = styled(Form)`
    width: 100%;
    .head-section {
        padding: 30px 15px;
        border-bottom: 1px solid rgba(233, 233, 233, 1);
    }
    .about-section {
        padding: 30px 15px;
        .about-title {
            font-size: 24px;
            line-height: 28px;
            font-weight: 400;
            margin-bottom: 20px;
        }
    }

    .input-field-wrap {
        .label {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
        }
        textarea {
            min-height: 110px;
        }
        .labelButton {
            height: 170px;
        }
    }
`;

const TextSection = () => {
    const [form] = useForm();
    return (
        <StyledTextSection form={form} onSubmit={e => console.log(e)}>
            <div className="head-section">
                <Form.Item
                    type="text"
                    label="Hero Title"
                    name="heroTitle"
                    placeholder="Fastest Delivery & Easy Pickup!"
                    $bgWhite>
                    <Field />
                </Form.Item>
                <Form.Item
                    type="text"
                    label="Hero Subtitle"
                    name="heroSubtitle"
                    placeholder="We are just a Click away when you Crave for Delicious Food!"
                    $bgWhite>
                    <Field />
                </Form.Item>
            </div>
            <div className="about-section">
                <h2 className="about-title">About Section</h2>
                <Form.Item type="text" label="Point 1" name="point1Title" placeholder="Fast Delivery" $bgWhite>
                    <Field />
                </Form.Item>
                <Form.Item
                    type="textarea"
                    name="point1Desc"
                    placeholder="The Food will be Delivered to you home within 40-60 mins of your Ordering."
                    $bgWhite>
                    <Field />
                </Form.Item>
                <Form.Item type="text" label="Point 2" name="point2Title" placeholder="Fast Delivery" $bgWhite>
                    <Field />
                </Form.Item>
                <Form.Item
                    type="textarea"
                    name="point2Desc"
                    placeholder="The Food will be Delivered to you home within 40-60 mins of your Ordering."
                    $bgWhite>
                    <Field />
                </Form.Item>
                <Form.Item type="text" label="Point 3" name="point3Title" placeholder="Fast Delivery" $bgWhite>
                    <Field />
                </Form.Item>
                <Form.Item
                    type="textarea"
                    name="point3Desc"
                    placeholder="The Food will be Delivered to you home within 40-60 mins of your Ordering."
                    $bgWhite>
                    <Field />
                </Form.Item>
            </div>
        </StyledTextSection>
    );
};

export default TextSection;
